import React from 'react';
import { useSearchParams } from 'react-router-dom';

import { useAppSelector } from 'hooks/typedReduxHooks';
import { RULES_FILTERS as filters } from 'constants/rules';
import { setMultiParamSelector } from 'utils/multiParamSelector';

import useSearchRules from 'hooks/useSearchRules';
import Sort from './Sort/Sort';
import Filter from './Filter/Filter';
import s from './Controls.module.css';
import ParamButton from './ParamButton/ParamButton';
import Search from './Search/Search';

const Controls = () => {
  const { getRules } = useSearchRules();
  const [searchParams, setSearchParams] = useSearchParams();
  const { profile } = useAppSelector((state) => state.auth);

  const clearFiltersFromSearchParams = () => {
    filters.forEach(({ name, options }) => {
      let filterOptions = options;
      if (name === 'priority' && profile?.role) {
        filterOptions = options[profile?.role];
      }
      const isMulti = filterOptions.length > 2;
      const searchParamName = isMulti ? setMultiParamSelector(name) : name;
      searchParams.delete(searchParamName);
    });
    searchParams.delete('login_ad');

    setSearchParams(searchParams);
    getRules([]);
  };

  return (
    <div className="w-full">
      <Search />
      <hr className="h-[0.5px] my-4 bg-[#969696] border-0" />
      <div className={s.container}>
        <Sort />
        {filters.map(({ options, name, placeholder }) => (
          <Filter
            options={
              name === 'priority' && profile?.role
                ? options[profile?.role]
                : options
            }
            name={name}
            placeholder={placeholder}
            key={name}
          />
        ))}
        {profile?.login_ad && (
          <ParamButton
            paramName="login_ad"
            paramValue={profile.login_ad}
            text={['Только мои', 'Все']}
          />
        )}
      </div>
      <button
        className={s.clearFilters}
        type="button"
        onClick={clearFiltersFromSearchParams}
      >
        Очистить фильтры
      </button>
    </div>
  );
};

export default Controls;
